/*jslint node: true*/

"use strict";

var dateBehaviour = require("pli/forms-knockoutcontrols-date").behaviours.date;
var ko = require("pli/knockout");
var numberUtil = require("pli/util/number");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var createUnitsFactory = require("../lease-unit");
var formattedBehaviour = require("../ko-behaviours-formatted");
var splitExtensions = require("../document-split/SplitViewModelExtensions");


//---------------------------------------
function extractNumber(record, name) {
    var value = record && record[name];
    return (numberUtil.isNumber(value) ? value : null);
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// LeaseSplitViewModelExtensions static class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function LeaseSplitViewModelExtensions(factories) {
    this.initSplit(factories);

    this.accountingCode = ko.observable("");
    this.acquired = pliObservable(null, null, dateBehaviour);
    this.expired = pliObservable(null, null, dateBehaviour, formattedBehaviour);
    this.extensionCode = ko.observable("");
    this.rentalPercentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric", formattedBehaviour);
    this.terminated = pliObservable(null, null, dateBehaviour);

    this.acreage = factories.createAcreage(factories);
    this.units = factories.units.createObservableArray();

    this.extras.rentalGross = ko.observable(null);
    this.extras.rentalTotalNet = ko.observable(null);
    this.extras.producingStatus = ko.computed(LeaseSplitViewModelExtensions.prototype._computeProducingStatus, this);

    this.extras.rentalGross.currency = ko.pureComputed(function () {
        return numberUtil.formatNumber(this.extras.rentalGross(), 'C2');
    }, this);

    this.extras.rentalTotalNet.currency = ko.pureComputed(function () {
        return numberUtil.formatNumber(this.extras.rentalTotalNet(), 'C2');
    }, this);
}


//---------------------------------------
LeaseSplitViewModelExtensions.prototype.applyServerCalculationResult = function applyLeaseSplitResult(context) {
    var record = context.currentData;
    this.extras.rentalGross(extractNumber(record, "rentalGross"));
    this.extras.rentalTotalNet(extractNumber(record, "rentalTotalNet"));

    context.visit(this.acreage, "acreage");
    context.visit(this.dois, "dois");
};


//---------------------------------------
LeaseSplitViewModelExtensions.prototype.buildServerCalculationData = function buildLeaseSplitData(context) {
    return {
        acreage: context.visit(this.acreage),
        dois: context.visit(this.dois),
        rentalPercentage: this.rentalPercentage(),
        status: this.status()
    };
};


//---------------------------------------
LeaseSplitViewModelExtensions.prototype.completeViewModel = function completeLeaseSplit() {
    this.completeSplit();
};


//---------------------------------------
LeaseSplitViewModelExtensions.prototype.initGridArray = function initLeaseSplitGridArray(gridArray) {
    this.initSplitGridArray(gridArray);
};


//---------------------------------------
LeaseSplitViewModelExtensions.prototype.loadViewModel = function loadLeaseSplit(record) {
    this.loadSplit(record);

    this.accountingCode(record.accountingCode || "");
    this.acquired.load(record.acquired);
    this.expired.load(record.expired);
    this.extensionCode(record.extensionCode || "");
    this.rentalPercentage.load(record.rentalPercentage);
    this.terminated.load(record.terminated);

    this.acreage.loadViewModel(record.acreage);
    this.units.loadViewModel(record.units);
};


//-------------------------------------------
LeaseSplitViewModelExtensions.prototype._computeProducingStatus = function computeSplitProducingStatus() {
    var index, status,
        producing = false;

    if (this.status.isActive()) {
        for (index = 0; !producing && index < this.relatedWells().length; index += 1) {
            status = this.relatedWells()[index].extras.producingStatus();
            if (status && status[0] === "P") { producing = true; }
        }
    }

    return (producing ? "Producing" : "Non-producing");
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = {
    createFactories: function createExtraLeaseSplitFactories(rootId, isRightsDisabled) {
        return ko.utils.extend({
            units: createUnitsFactory(rootId)
        }, splitExtensions.createFactories(rootId, false, isRightsDisabled));
    },
    mixins: ko.utils.extend({
        applyLeaseSplitResult: LeaseSplitViewModelExtensions.prototype.applyServerCalculationResult,
        buildLeaseSplitData: LeaseSplitViewModelExtensions.prototype.buildServerCalculationData,
        completeLeaseSplit: LeaseSplitViewModelExtensions.prototype.completeViewModel,
        initLeaseSplit: LeaseSplitViewModelExtensions,
        initLeaseSplitGridArray: LeaseSplitViewModelExtensions.prototype.initGridArray,
        loadLeaseSplit: LeaseSplitViewModelExtensions.prototype.loadViewModel
    }, splitExtensions.mixins)
};



//////////////////
// WEBPACK FOOTER
// ./app/lease-split/leaseSplitViewModelExtensions.js
// module id = 650
// module chunks = 49